import { createPopper } from '@popperjs/core'
import './templateSelectDropdown.scss'

export function positionTemplateDropdown(dropdownList, component, { width }) {
  dropdownList.classList.add('communication-template-select-options')
  dropdownList.style.width = width
  dropdownList.style.zIndex = '10020'
  const popper = createPopper(component.$refs.toggle, dropdownList, {
    placement: 'bottom-start',
    modifiers: [
      { name: 'offset', options: { offset: [0, 6] } },
      { name: 'flip', options: { fallbackPlacements: ['top-start'] } },
      { name: 'preventOverflow', options: { padding: 12 } }
    ]
  })
  return () => popper.destroy()
}
